export default (state = { loading: true, list: [], edit: undefined, selected: [] }, action) => {

  switch (action.type) {
    case 'ELITERATURE_FETCH_BEGIN':
      return { ...state, loading: true };
    case 'ELITERATURE_FETCH_SUCCESS':
      return { ...state, list: action.payload.eliterature.entries, orgName: action.payload.orgName, orgId: action.payload.orgId, loading: false };
    case 'ELITERATURE_SAVE_SUCCESS':
      return { ...state };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/eliterature/eliteratureReducers.js